<script>
  import {Bar, mixins} from 'vue-chartjs'
  // import the component - chart you need

  // Extend it
  export default {
    extends: Bar,
    mixins: [mixins.reactiveProp],
    props: ['overallPointsLabel','overallPointsColor','overallPointsData','overallPointsID','groupID'],
    data() {
        var _this = this;
        return {
            datacollection: {
                labels: this.overallPointsLabel,
                datasets: [
                    {
                        label: 'Data One',
                        backgroundColor: this.overallPointsColor,
                        data: this.overallPointsData
                    }
                ]
            },
            options: {
                responsive: false,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                    position: 'bottom'
                },                
                scales: {
                    xAxes: [{
                        ticks: {
                            autoSkip: false,
                            maxRotation: 90,
                            minRotation: 90
                        }
                    }]
                },
                onClick: function(evt,arr) {
                    //alert(array)
                    _this.graphClickEvent(evt,arr);
                }
            }
        }
    },
    methods: {
        graphClickEvent(evt,arr){
            var label = arr[0]['_model'].label
            var index = arr[0]['_index']
            
            this.$store.commit('UPDATE_VIEW_GROUP_ID',this.groupID)
            this.$store.commit('UPDATE_POSITIVE_BEHAVIOR_ID',this.overallPointsID[index])
            this.$store.commit('UPDATE_POSITIVE_BEHAVIOR_NAME',label)
            this.$store.commit('UPDATE_POSITIVE_PERIOD',2)  //2 for Overall
            localStorage.setItem('VIEW_GROUP_ID',this.groupID)
            localStorage.setItem('POSITIVE_BEHAVIOR_ID',this.overallPointsID[index])
            localStorage.setItem('POSITIVE_BEHAVIOR_NAME',label)
            localStorage.setItem('POSITIVE_PERIOD',2)  //2 for Overall

            this.$router.push({
                name: "GroupPositiveDetails"
            });
        }
    },
    mounted () {
      // Overwriting base render method with actual data and options
      this.renderChart(this.datacollection, this.options)
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Group/Charts/OverallPoints.vue